// Constants for TextArea
var DEFAULT_ROWS = 5;

export { DEFAULT_ROWS };
